import { MatxLoadable } from "matx";
import { isMdScreen, getQueryParam } from "utils";

const Home = MatxLoadable({
    loader: () => import("./Home")
});
const KudosForm = MatxLoadable({
  loader: () => import("../menuHome/forms/KudosForm")
});
const settings = {
    activeLayout: "layout1",
    layout1Settings: {
      topbar: {
        show: true
      },
      leftSidebar: {
        show: true,
        mode: isMdScreen() ? "close" : "full"
      }
    },
    likeDislikeButtons: { show: false }
  };
const sykesHomeRoutes = [
    {
        path: "/Inicio",
        component: Home,
        settings
    },
    {
      path: "/Kudos/Form/:id",
      component: KudosForm,
      settings
    },
    {
      path: "/Kudos/Form",
      component: KudosForm,
      settings
    },
];

export default sykesHomeRoutes
